import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Input, InputWrapper, LabelText, SubmitButton, FlexContainer, H1Text, Hr, Text, Img } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Select from 'react-select'
import { COUNTRY_PHONE_CODE, EMAIL } from "../../appconstants";
import { axiosLoginInstance, BASE_URLS, API, getLocationDetails, getRecaptchToken } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import queryString from 'query-string';
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import NumberFormat from "react-number-format";
import ReCAPTCHA from 'react-google-recaptcha';

type Props = {
    history: {
        push: Function,
    },
}

const PartnerLogin = (props: Props) => {
    const { location } = props;
    const { handleSubmit, errors, control, reset } = useForm();
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [inputPhoneReadOnly, setInputPhoneReadOnly] = useState(false);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [publicKey, setPublicKey] = useState('');
    const parsed = queryString.parse(location.search);
    const [partnerName, setPartnerName] = useState('');
    const [countryCode, setCountryCode] = useState('+1');
    const [sitekey, setSitekey] = useState();
    const [recaptchaToken, setRecaptchToken] = useState(null);
    const [isSignup, setIsSignup] = useState(false);
    const [showCaptchError, setShowCaptchError] = useState(null);
    const [bussinessActive, setBussinessActive] = useState(null);
    const [portal, setPortal] = useState(null);
    const recaptchaRef = useRef(null);
    useEffect(() => {
        // getDefaultCountryPostal();
        localStorage.setItem(
            'createVirtualAccount',
            parsed.createVirtualAccount ? parsed.createVirtualAccount : 'false'
        );
        setPublicKey(parsed ? atob(parsed.key) : '');
        localStorage.setItem('publicKey', atob(parsed.key));
        if (parsed.redirectUrl) {
            localStorage.setItem('redirectUrl', parsed.redirectUrl);
        }
        getRecaptha();
        if (parsed?.mode === 'AUTH') {
            localStorage.setItem('authMode', parsed?.mode);
        }
    }, [location, parsed]);

    const removeCountryCode = (phoneNumber) => {
      if (phoneNumber.startsWith('+1')) {
          return phoneNumber.slice(2); // removes +1
      } else if (phoneNumber.startsWith('+91')) {
          return phoneNumber.slice(3);
      }
      return phoneNumber;
  };

  const getAfflicateData = async () => {
    try {
      const config = {
        headers: {
          'x-api-key': publicKey,
        }
      };
      const { data: { entity } } = await API.get(`${BASE_URLS.AFFILIATE_ACCOUNT}/${parsed?.affiliateId}`, config);
      if (entity) {
        reset({
            fname: entity?.name,
            email: entity?.email,
            phone: entity?.phoneNumber ? removeCountryCode(entity?.phoneNumber) : null,
        });
        setReadOnly(["phone", "email"]);
      }
    } catch (reason) {
      console.log(reason);
    }
  }

    const getRecaptha = async () => {
        try {
            const value = await getRecaptchToken();
            if (value) {
                setSitekey(value.siteKey);
                setIsSignup(value.signup);
            }
        } catch (reason) {
            console.log(reason);
        }
    };

    const handleReload = () => {
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
            setRecaptchToken('');
        }
    };

    // const getDefaultCountryPostal = async () => {
    //     try {
    //         const data = await getLocationDetails();
    //         setCountryCode(data && data.country_calling_code);
    //     } catch (e) {
    //         console.log(e);
    //     }
    // };

    const onSubmit = async (data) => {
        if (recaptchaToken) {
            setShowCaptchError(null);
        } else {
            setShowCaptchError('Captcha is required');
        }
        const params = {
            email: data.email.trim(),
            familyName: data.lname.trim(),
            givenName: data.fname.trim(),
            phoneNumber: `${data.countryCallingCode.value}${data.phone}`,
            recaptchaToken,
            platformType: 'WEB',
        };
        localStorage.setItem('email', data.email.trim());
        if (isSignup === true) {
            if (recaptchaToken) {
                try {
                    await axiosLoginInstance.post(`${BASE_URLS.USER_REGISTER}`, params);
                    setSuccess(true);
                } catch (e) {
                    setShowErrorMessage(true);
                    handleReload();
                    setErrorMessage(e && e.data ? (e.data.message === 'User Already Exist' ? 'Email already exists please use the link to sign in.' : e.data.message) : 'Unable to process request. Please try again later');
                }
            }
        } else {
            try {
                await axiosLoginInstance.post(`${BASE_URLS.USER_REGISTER}`, params);
                setSuccess(true);
            } catch (e) {
                setShowErrorMessage(true);
                handleReload();
                setErrorMessage(e && e.data ? (e.data.message === 'User Already Exist' ? 'Email already exists please use the link to sign in.' : e.data.message) : 'Unable to process request. Please try again later');
            }
        }
    }
    useEffect(() => {
        setInputPhoneReadOnly(readOnly && readOnly.includes("phone"))
    }, [readOnly]);

    useEffect(() => {
      if (success) {
            props.history.replace('/temppassword');
        localStorage.removeItem('authMode');
        }
    }, [success]);

    useEffect(() => {
        if(publicKey){
        getData();
        if (parsed?.affiliateId) {
            getAfflicateData();
            localStorage.setItem('affiliateId', parsed?.affiliateId);
        } else if (!parsed?.affiliateId) {
            localStorage.removeItem('affiliateId', parsed?.affiliateId);
        }
    }
    }, [publicKey, parsed?.affiliateId]);

    const getData = async () => {
        if (!publicKey) {
            props.history.push('/error');
            return;
        }
        try {
            const config = {
                headers: {
                    'x-api-key': publicKey,
                }
            };
            const { data: { entity: { name, active, portal } } } = await API.get(BASE_URLS.PUBLICKEY_PROFILE, config);
            setPartnerName(name);
            setBussinessActive(active);
            setPortal(portal && portal.test);
        } catch (e) {
            const status = e?.status || e?.response?.status;
            const responseCode = e?.data?.responseCode || e?.response?.data?.responseCode;
            if (status === 401 || responseCode === 401) {
                props.history.push('/error');
            } else {
                setShowErrorMessage(true);
                setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
            }
        }
    };

    const customStyles = {
        control: base => ({
            ...base,
            height: 32,
            minHeight: 32,
            border: 'none',
            borderRight: '1px solid #29B1CC',
            boxShadow: 'none',
            borderColor: '#29B1CC !important'
        }),
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <H1Text>
                            Configure Payments
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >

                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        ACCOUNT SETUP
                    </H1Text>

                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        To complete setup with {partnerName ? partnerName : ''} please provide us a few quick details to create a free account with Swirepay.
                    </Text>
                    <Hr />
                    {
                        countryCode && (
                            <div className="px-1 px-md-4 mt-2">
                                <FlexContainer
                                    flexDirection="column"
                                >
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <LabelText className="mt-4 mb-2">
                                            First Name
                                        </LabelText>
                                        <Controller
                                            defaultValue={""}
                                            control={control}
                                            color={errors.fname ? "red" : "inherit"}
                                            marginBottom="0px"
                                            name="fname"
                                            placeholder="Enter your First Name"
                                            rules={{
                                                required: 'First Name is required'
                                            }}
                                            as={<Input readOnly={readOnly && readOnly.includes("fname")} />}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="fname"
                                            render={({ message }) => (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                            )}
                                        />
                                        <LabelText className="mt-4 mb-2">
                                            Last Name
                                        </LabelText>
                                        <Controller
                                            defaultValue={""}
                                            control={control}
                                            color={errors.lname ? "red" : "inherit"}
                                            marginBottom="0px"
                                            name="lname"
                                            placeholder="Enter your Last Name"
                                            rules={{
                                                required: 'Last Name is required'
                                            }}
                                            as={<Input readOnly={readOnly && readOnly.includes("lname")} />}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="lname"
                                            render={({ message }) => (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                            )}
                                        />
                                        <LabelText className="mt-4 mb-2">
                                            E-Mail
                                        </LabelText>
                                        <Controller
                                            marginBottom="0px"
                                            defaultValue={""}
                                            control={control}
                                            name="email"
                                            placeholder="Enter your email address"
                                            rules={{
                                                required: 'Email is required',
                                                pattern: {
                                                    value: EMAIL.DEFAULT_REGEX,
                                                    message: EMAIL.DEFAULT_ERROR_MESSAGE,
                                                },
                                            }}
                                            as={<Input readOnly={readOnly && readOnly.includes("email")} />}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="email"
                                            render={({ message }) => (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                            )}
                                        />
                                        <LabelText className="mt-4 mb-2">
                                            Phone
                                        </LabelText>
                                        <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='299px'>
                                            <Controller
                                                defaultValue={{ value: countryCode }}
                                                color={errors.countryCallingCode ? "red" : "inherit"}
                                                marginBottom="0px"
                                                control={control}
                                                name="countryCallingCode"
                                                placeholder="select"
                                                rules={{
                                                    required: 'Calling Code is required'
                                                }}
                                                as={<Select
                                                    className="col-4 px-0 border-0"
                                                    isSearchable={!inputPhoneReadOnly}
                                                    menuIsOpen={inputPhoneReadOnly ? false : undefined}
                                                    theme={theme => ({
                                                        ...theme,
                                                        borderRadius: "4px 0 0 4px",
                                                        boxShadow: 0
                                                    })}
                                                    getOptionLabel={(option) => option.value}
                                                    styles={customStyles}
                                                    options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                                            />
                                            <Controller
                                                className="col"
                                                defaultValue={""}
                                                // color={errors.phone ? "red" : "inherit"}
                                                border="0px !important"
                                                marginBottom="0px"
                                                marginTop="0px"
                                                marginLeft="0px"
                                                paddingRight="0"
                                                control={control}
                                                name="phone"
                                                rules={{
                                                    required: 'Phone number is required',
                                                    pattern: {
                                                        value: /^\d{6,12}$/,
                                                        message: 'The phone number is invalid',
                                                    },
                                                }}
                                                as={<NumberFormat type="tel" minLength={6} maxLength={10} allowNegative={false} decimalScale={0} readOnly={inputPhoneReadOnly} />}
                                                placeholder="Enter your phone number"
                                                customInput={Input}
                                            />
                                        </InputWrapper>
                                        <ErrorMessage
                                            errors={errors}
                                            name="phone"
                                            render={({ message }) => (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                            )}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="countryCallingCode"
                                            render={({ message }) => (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                            )}
                                        />
                                        {
                                            sitekey && (isSignup === true) && (
                                                <div className="mt-3">
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        className="g-recaptcha"
                                                        sitekey={sitekey}
                                                        value={recaptchaToken}
                                                        onChange={(value) => {
                                                            setRecaptchToken(value);
                                                            setShowCaptchError(null);
                                                        }}
                                                    />
                                                    {
                                                        (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                                        ) : showCaptchError ? (
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                                        ) : ''
                                                    }
                                                </div>
                                            )
                                        }
                                        <div className="mb-3">
                                            {
                                                bussinessActive ? (
                                                    <>
                                                        <SubmitButton
                                                            type="submit"
                                                            style={{ width: '292px' }}
                                                        >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                        <Text>
                                                            Already have a Swirepay account? <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => props.history.push('/login')}>Sign In</span>
                                                        </Text>
                                                    </>
                                                ) : (!bussinessActive && (portal === false)) ? (
                                                    <>
                                                        <SubmitButton
                                                            disabled
                                                            type="submit"
                                                            style={{ width: '292px' }}
                                                        >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                        <Text>
                                                            Please provide business details and active your account before adding an affiliate account.
                                                        </Text>
                                                    </>
                                                ) : (
                                                    <>
                                                        <SubmitButton
                                                            type="submit"
                                                            style={{ width: '292px' }}
                                                        >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                        <Text>
                                                            Already have a Swirepay account? <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => props.history.push('/login')}>Sign In</span>
                                                        </Text>
                                                    </>
                                                )
                                            }
                                        </div>
                                        {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                                    </form>
                                </FlexContainer>
                            </div>
                        )
                    }
                </FlexContainer>
            </>
        } />
    )
};

export default PartnerLogin;
